import { apiGet } from '@/api/http';

export const getIndustries = () =>
  apiGet<{ id: string; name: string }[]>(
    `${import.meta.env.VITE_API_URL}industries/`,
  );
